import { render } from "./invoiceForm.vue?vue&type=template&id=96fa66b4&scoped=true"
import script from "./invoiceForm.vue?vue&type=script&lang=js"
export * from "./invoiceForm.vue?vue&type=script&lang=js"

import "./invoiceForm.vue?vue&type=style&index=0&id=96fa66b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96fa66b4"]])

export default __exports__